import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Dialog, Field, Input } from '@dossierhq/design';
import { useCallback, useEffect, useState, } from 'react';
import { SchemaEditorActions, } from '../../reducers/SchemaEditorReducer/SchemaEditorReducer.js';
const DialogStatus = {
    alreadyExist: 'alreadyExist',
    empty: 'empty',
    invalidFormat: 'invalidFormat',
    noChange: 'noChange',
    valid: 'valid',
};
//TODO use from core?
const CAMEL_CASE_PATTERN = /^[a-z][a-zA-Z0-9_]*$/;
const NAME_DEFAULT_HELP_TEXT = 'The name of the index, such as myIndex';
const NAME_STATUS_HELP_TEST = {
    [DialogStatus.invalidFormat]: 'The index name has to start with a lower-case letter (a-z) and can only contain letters (a-z, A-Z), numbers and underscore (_), such as myIndex_123',
    [DialogStatus.alreadyExist]: 'An index with that name already exists',
};
export function AddOrRenameIndexDialog({ selector, schemaEditorState, dispatchSchemaEditorState, onClose, }) {
    const [name, setName] = useState('');
    const [status, setStatus] = useState(DialogStatus.empty);
    const handleNameChange = useCallback((event) => {
        setName(event.target.value);
    }, []);
    const handleClose = useCallback(async (_event, returnValue) => {
        if (!selector) {
            return;
        }
        if (returnValue === 'ok') {
            if (selector === 'add') {
                dispatchSchemaEditorState(new SchemaEditorActions.AddIndex(name));
            }
            else {
                dispatchSchemaEditorState(new SchemaEditorActions.RenameIndex(selector, name));
            }
        }
        onClose();
        setStatus(DialogStatus.empty);
    }, [dispatchSchemaEditorState, name, onClose, selector]);
    useEffect(() => {
        // TODO resolve eslint error
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setName(selector && selector !== 'add' ? selector.name : '');
    }, [selector]);
    useEffect(() => {
        const newStatus = selector
            ? validateName(schemaEditorState, selector, name)
            : DialogStatus.empty;
        // TODO resolve eslint error
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setStatus(newStatus);
    }, [name, schemaEditorState, selector]);
    return (_jsx(Dialog, { show: !!selector, form: true, modal: true, onClose: handleClose, children: selector ? (_jsx(DialogContent, { selector,
            status,
            name,
            schemaEditorState,
            onNameChange: handleNameChange,
            onEnterKeyPress: () => status === DialogStatus.valid && handleClose(null, 'ok') })) : null }));
}
function validateName(schemaEditorState, selector, name) {
    if (!name)
        return DialogStatus.empty;
    if (!name.match(CAMEL_CASE_PATTERN)) {
        return DialogStatus.invalidFormat;
    }
    if (selector !== 'add' && selector.name === name) {
        return DialogStatus.noChange;
    }
    if (schemaEditorState.indexes.find((it) => it.name === name)) {
        return DialogStatus.alreadyExist;
    }
    return DialogStatus.valid;
}
function DialogContent({ selector, status, name, onNameChange, onEnterKeyPress, }) {
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onEnterKeyPress();
        }
    }, [onEnterKeyPress]);
    const isRename = selector !== 'add';
    const nameColor = Object.keys(NAME_STATUS_HELP_TEST).includes(status) ? 'danger' : undefined;
    return (_jsxs(Card, { children: [_jsx(Card.Header, { children: _jsx(Card.HeaderTitle, { children: isRename ? 'Rename index' : 'Add index' }) }), _jsx(Card.Content, { children: _jsxs(Field, { children: [_jsx(Field.Label, { children: "Name" }), _jsx(Field.Control, { children: _jsx(Input, { placeholder: "Enter name\u2026", color: nameColor, value: name, onChange: onNameChange, onKeyDown: handleKeyDown }) }), _jsx(Field.Help, { color: nameColor, children: NAME_STATUS_HELP_TEST[status] ?? NAME_DEFAULT_HELP_TEXT })] }) }), _jsxs(Card.Footer, { children: [_jsx(Card.FooterButton, { children: "Cancel" }), _jsx(Card.FooterButton, { value: "ok", disabled: status !== DialogStatus.valid, children: isRename ? 'Rename' : 'Add' })] })] }));
}
//# sourceMappingURL=AddOrRenameIndexDialog.js.map